import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

const ProtectedRoute = ({ children }) => {
  const auth = getAuth();
  const [isLoading, setIsLoading] = useState(true);
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(false);

  useEffect(() => {
    // Listener for auth state
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsUserAuthenticated(!!user);
      setIsLoading(false);
    });

    // Clean up the listener when the component unmounts
    return unsubscribe;
  }, [auth]);

  if (isLoading) {
    return <div>Loading...</div>; // Replace with your loading indicator as needed
  }

  return isUserAuthenticated ? children : <Navigate to="/login" />;
};

export default ProtectedRoute;
